module.exports = __webpack_public_path__ + "img/briefcase.0dd9f14d.png";